import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-index-landing-two',
  templateUrl: './index-landing-two.component.html',
  styleUrls: ['./index-landing-two.component.css']
})

/***
 * Landing Two Component
 */
export class IndexLandingTwoComponent implements OnInit {

  // Set Topbar Option
  Menuoption = 'center';
  Settingicon = true
  /**
   * Blog Data
   */
  blogData = [
    {
      image: "assets/images/blog/01.jpg",
      title: "Design your apps in your own way",
      like: "33",
      message: "08",
      name: "Calvin Carlo",
      date: "13th August, 2019"
    },
    {
      image: "assets/images/blog/02.jpg",
      title: "How apps is changing the IT world",
      like: "33",
      message: "08",
      name: "Calvin Carlo",
      date: "13th August, 2019"
    },
    {
      image: "assets/images/blog/03.jpg",
      title: "Smartest Applications for Business",
      like: "33",
      message: "08",
      name: "Calvin Carlo",
      date: "13th August, 2019"
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }


}
